export default "__VITE_ASSET__CKv7191X__"